module.exports = __webpack_public_path__ + "img/OLIMP.b14b9d6b.svg";